const FIXE_SITE_URL = 'https://fixecrm.com';

/**
 * Rodapé de marca — logo enviado pelo time (`public/fixe-crm-fidelidade.png`) + copyright.
 * Na área do participante (`onHomeClick`), o logo leva ao início; o link do site fica no texto.
 */
export function PublicInviteFooter({ onHomeClick }: { onHomeClick?: () => void } = {}) {
  const year = new Date().getFullYear();
  const logo = (
    <img
      src="/fixe-crm-fidelidade.png"
      alt="Fixe CRM & Fidelidade"
      width={195}
      height={90}
      className="h-14 w-auto object-contain dark:invert"
    />
  );

  return (
    <footer className="flex flex-col items-center gap-3 px-4 pb-2 pt-8 text-center">
      {onHomeClick ? (
        <button
          type="button"
          onClick={onHomeClick}
          className="rounded-lg opacity-80 transition-opacity hover:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label="Ir para o início"
        >
          {logo}
        </button>
      ) : (
        <a
          href={FIXE_SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="opacity-80 transition-opacity hover:opacity-100"
          aria-label="FixeCRM"
        >
          {logo}
        </a>
      )}
      <div className="space-y-0.5">
        <a
          href={FIXE_SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="block text-xs font-medium text-muted-foreground transition-colors hover:text-foreground"
        >
          fixecrm.com
        </a>
        <p className="text-[11px] text-muted-foreground/70">
          © {year} FixeCRM. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}
